/**
 * フェードインアニメーションスクリプト
 *
 */

function fadeIn(elements) {
    const startPosition = $(window).scrollTop() + $(window).height();
    elements.each(function(index) {
        if(startPosition > $(this).offset().top) {
 			$(this).addClass('fade-in');
        }
    });
}


$(window).on('load', function() {
	const elements = $('.u-animation__fade-in--left, .u-animation__fade-in--right, .u-animation__fade-in--top, .u-animation__fade-in--bottom');
	if(elements.length) {
		fadeIn(elements);
		$(window).on('scroll', function() {
			fadeIn(elements);
		});
	}
});